import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

const UIFilterDateTime = ({ value, format = 'DD/MM/YY' }) => dayjs(value).locale('pt-br').format(format)

export default UIFilterDateTime
